import { render, staticRenderFns } from "./CheckoutDesc.vue?vue&type=template&id=0229f756&scoped=true&"
import script from "./CheckoutDesc.vue?vue&type=script&lang=js&"
export * from "./CheckoutDesc.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutDesc.vue?vue&type=style&index=0&id=0229f756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229f756",
  null
  
)

export default component.exports